/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/schEducations/schEducationsActions";
import { useSchEducationsUIContext } from "../SchEducationsUIContext";

export function SchEducationDeleteDialog({ id, show, onHide }) {
  // SchEducations UI Context
  const schEducationsUIContext = useSchEducationsUIContext();
  const schEducationsUIProps = useMemo(() => {
    return {
      setIds: schEducationsUIContext.setIds,
      queryParams: schEducationsUIContext.queryParams,
    };
  }, [schEducationsUIContext]);

  // SchEducations Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.schEducations.actionsLoading }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteSchEducation = () => {
    // server request for deleting schEducation by id
    dispatch(actions.deleteSchEducation(id)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchSchEducations(schEducationsUIProps.queryParams));
      // clear selections list
      schEducationsUIProps.setIds([]);
      // closing delete modal
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          SchEducation Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to permanently delete this schEducation?</span>
        )}
        {isLoading && <span>SchEducation is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteSchEducation}
            className="btn btn-delete btn-elevate"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
